import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type {
  QuizAttempt,
  QuizAttemptQuestion,
} from "@/react/types/QuizAttempt";
import type { QuizQuestion } from "@/react/types/QuizQuestion";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";
import { OptionItem } from "./OptionItem";
import { QuestionCorrectStatus } from "./QuestionCorrectStatus";

const shouldShowCorrectAnswer = (
  question: QuizQuestion | QuizAttemptQuestion,
): question is QuizAttemptQuestion => "correct" in question;
interface QuestionItemProps {
  checkQuizCompleted: () => void;
  lastAttempt: QuizAttempt | null;
  question: QuizQuestion | QuizAttemptQuestion;
  questionIndex: number;
}
export const QuestionItem = ({
  question,
  questionIndex,
  checkQuizCompleted,
  lastAttempt,
}: QuestionItemProps) => {
  const { setValue } = useFormContext();
  useEffect(() => {
    setValue(`responses[${questionIndex}][quizzes_question_id]`, question.id);
  }, [question.id, questionIndex, setValue]);
  return (
    <div>
      {question.cover_media && (
        <div className="bg-secondary group relative mb-5 aspect-[2.7388059701] w-full rounded-lg">
          <img
            src={question.cover_media.url}
            loading="lazy"
            alt={t("courses.edit.lesson.cover_media_alt")}
            className="h-full w-full rounded-lg"
          />
        </div>
      )}
      <Typography.LabelMd weight="semibold">
        {question.statement}
      </Typography.LabelMd>
      {shouldShowCorrectAnswer(question) && (
        <QuestionCorrectStatus question={question} />
      )}
      <Form.Input
        type="hidden"
        name={`responses[${questionIndex}][quizzes_question_id]`}
        value={question.id}
      />
      {question.options.map((option, optionIndex) => (
        <OptionItem
          key={option.id}
          question={question}
          option={option}
          questionIndex={questionIndex}
          optionIndex={optionIndex}
          checkQuizCompleted={checkQuizCompleted}
          readOnly={!!lastAttempt}
        />
      ))}
    </div>
  );
};
